<template>
    <div>
        <div class="nav-vertical">
            <ul class="nav nav-tabs nav-left" role="tablist">
                <li v-if="rowData.doc_fiscal_volume_ocorrencia.length > 0" class="nav-item">
                    <a class="nav-link active" v-bind:href="'#Ocorrencias' + rowData.docfisvol_id" role="tab"
                        data-toggle="tab">
                        <span class="nav-link-in">
                            Ocorrencias
                            <i class="fa fa-bulding"></i>
                        </span>
                    </a>
                </li>
                <li v-if="rowData.doc_fiscal_volume_log.length > 0" class="nav-item">
                    <a class="nav-link" v-bind:href="'#Logs' + rowData.docfisvol_id" role="tab" data-toggle="tab">
                        <span class="nav-link-in">Logs<i class="fa fa-bulding"></i></span>
                    </a>
                </li>

                <li v-if="rowData.doc_fiscal_volume_bip.length > 0" class="nav-item">
                    <a class="nav-link" v-bind:href="'#Bips' + rowData.docfisvol_id" role="tab" data-toggle="tab">
                        <span class="nav-link-in">Bips<i class="fa fa-bulding"></i></span></a>
                </li>
            </ul>

            <div class="tab-content">
                <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                    v-bind:id="'Ocorrencias' + rowData.docfisvol_id">
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th width="20%">Descrição</th>
                                <th width="5%">Data</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="bg-gray-light" style="display: table-row;"
                                v-for="item in rowData.doc_fiscal_volume_ocorrencia">
                                <td>
                                    {{ item.descr }}
                                </td>
                                <td>
                                    {{ parseDatetime(item.dt_inc) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div role="tabpanel" class="tab-pane fade in pt-1 border-color-detalhes-grey"
                    v-bind:id="'Logs' + rowData.docfisvol_id">
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th width="10%">Cód. Barra</th>
                                <th width="10%">Data</th>
                                <th width="5%">Descrição</th>
                                <th width="5%">Tipo</th>
                                <th width="5%">Usuário</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="bg-gray-light" style="display: table-row;"
                                v-for="item in rowData.doc_fiscal_volume_log">
                                <td>
                                    {{ item.cd_barra }}
                                </td>
                                <td>
                                  {{ parseDatetime(item.dt_inc) }}
                                </td>
                                <td>
                                    {{ item.descr }}
                                </td>
                                <td>
                                    <span class="badge badge-success" v-if="item.tp_log.valor == 1">{{ item.tp_log.descr
                                        }}</span>
                                    <span class="badge badge-danger" v-if="item.tp_log.valor == 2">{{ item.tp_log.descr
                                        }}</span>
                                </td>
                                <td>
                                    {{ item.usuario_inc.email }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div role="tabpanel" class="tab-pane fade in pt-1 border-color-detalhes-grey"
                    v-bind:id="'Bips' + rowData.docfisvol_id">
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th width="10%">Cód. Barra</th>
                                <th width="5%">Pallet</th>
                                <th width="5%">Tipo Area</th>
                                <th width="5%">Data</th>
                                <th width="5%">Usuário</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="bg-gray-light" style="display: table-row;"
                                v-for="item in rowData.doc_fiscal_volume_bip">
                                <td>
                                    {{ item.cd_barra }}
                                </td>
                                <td>
                                    {{ item.pallet_id ? "P" + item.pallet_id : "N/A" }}
                                </td>
                                <td>
                                    A{{ item.area_id ? item.area_id : "N/A" }}
                                </td>
                                <td>
                                    {{ parseDatetime(item.dt_inc) }}
                                </td>
                                <td>
                                    {{ item.usuario_inc.email }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {formatDateTime, formatCNPJ, formatToBrazilianDate} from '../utils';

export default {
    props: {
        rowData: {
            type: Object,
            required: true
        },
        rowIndex: {
            type: Number
        }
    },
    methods: {
        parseDatetime(data) {
            return formatToBrazilianDate(data);
        },

        formatCNPJ(data) {
            return formatCNPJ(data);
        },

        getPartTipoAreaName(id) {
            switch(id) {
                case 1: return "Recebimento";
                case 2: return "Triagem";
                case 3: return "Inventário";
                default: return "N/A";
            }
        }
    }

}
</script>
